export default {
    components: {
      normalList: () => import('@/components/normalListView/index.vue')
    },
    data () {
      return {
        noData: false,
        page: 0,
        pageSize: 50,
        totalPage: 0,
        list: [],
        initComplete: false
      }
    },
    methods: {
      callback () {
        this.initComplete = true
        this.$refs.normalList.loading = false
        this.$refs.normalList.finished = this.list.length >= this.totalPage
        this.noData = this.list.length == 0
        this.$refs.normalList.finishedText = this.noData ? '' : '没有更多了'
      }
    }
  }
  